import { makeStyles } from '@material-ui/core'

const useStyles = makeStyles((theme) => ({
  root: {},
  text: {
    padding: '5px 10px',
    borderRadius: 18,
    color: theme.palette.error.contrastText,
    width: 'fit-content',
    display: 'flex',
    '& svg': {
      fontSize: 22,
      verticalAlign: 'text-top',
      marginLeft: 5,
      color: theme.palette.error.contrastText,
      '&:hover': { color: theme.palette.error.contrastText }
    }
  },
  red: {
    backgroundColor: theme.palette.error.main
  },

  green: {
    backgroundColor: theme.palette.success.main
  },
  yellow: {
    backgroundColor: theme.palette.warning.main
  }
}))

export default useStyles
